import { FC } from 'react';

import { UserAvatar, UserPopover } from '@bonusly/common-user-popover';
import { Flex, Text } from '@bonusly/design-system';

import { ProfileLink } from '../../../../modules/profile/components/profile-link';
import { formatDisplayDate } from '../../utils/date';

export interface AnnouncementHeaderProps {
	createdById: string;
	startDate: string;
}

export const AnnouncementHeader: FC<AnnouncementHeaderProps> = ({ createdById, startDate }) => {
	const formattedDate = formatDisplayDate(startDate);

	return (
		<Flex direction="column" alignItems="flex-start" gap={1} flexShrink={0}>
			<UserPopover userId={createdById}>
				<ProfileLink userId={createdById}>
					<UserAvatar userId={createdById} />
				</ProfileLink>
			</UserPopover>

			<Text color="text.softest" fontSize={50} fontWeight="normal" lineHeight={5}>
				{formattedDate}
			</Text>
		</Flex>
	);
};
